import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

import FormatUtils from '@front/squirtle/utils/format'

const Row = ({ row }) => <>
  <TableCell size={'small'}><TextCell value={row?.type?.name_translated} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.info?.plaque} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.info?.model?.brand?.name} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.info?.model?.name} /></TableCell>
  <TableCell size={'small'}><TextCell value={FormatUtils.formatDateBackToFront(row?.info?.in_service_date, 'DD/MM/YYYY')} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.parent_license?.license_number} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.parent_license?.license_client_id} /></TableCell>
  <TableCell size={'small'}><TextCell value={row?.group?.group_client_id} /></TableCell>
</>

export default React.memo(Row)
